import { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../redux/slices/authenticationSlice";
import { useNavigate } from "react-router";
import { setIsBottomBarVisible } from "../redux/slices/commonSlice";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import { Stack } from "@mui/system";
import colaLogo from "../assets/CC-logo.png";
import RulesModal from "./RulesModal";

const settings = ["Profil", "Pravilnik", "Izloguj se"];

function TopBar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [anchorElUser, setAnchorElUser] = useState();
  const [openRulesModal, setOpenRulesModal] = useState(false);
  const userMe = useSelector((state) => state.user.userMe);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  //   const handleCloseNavMenu = () => {
  //     setAnchorElNav(null);
  //   };

  const handleCloseUserMenu = (event) => {
    if (event.target.textContent === "Izloguj se") {
      dispatch(logOut()).then(() => {
        // navigate("/login");
        logout();
      });
    }
    if (event.target.textContent === "Profil") {
      dispatch(setIsBottomBarVisible(false));
      navigate("/home/profile");
    }
    if (event.target.textContent === "Pravilnik") {
      setOpenRulesModal(true);
    }
    setAnchorElUser(null);
  };

  return (
    <AppBar
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "#F40002",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {t("companyName")}
          </Typography>
          <Stack
            marginRight={1}
            sx={{
              backgroundColor: "white",
              padding: "1px 4px",
              borderRadius: "5px",
            }}
          >
            <img src={colaLogo} alt="logo" width="40px" />
          </Stack>
          <Typography
            variant="subtitle1"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {t("companyName")}
          </Typography>

          <Box sx={{ flexGrow: 0 }}>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar alt={userMe?.username} src={userMe?.avatar?._url} />
            </IconButton>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
      {openRulesModal && (
        <RulesModal
          open={openRulesModal}
          onClose={() => setOpenRulesModal(false)}
        />
      )}
    </AppBar>
  );
}
export default TopBar;
